import { z } from "zod"

export const climateZoneSchema = z.object({
  territoryId: z.number(),
  territoryName: z.string(),
  lseId: z.number(),
  lseName: z.string(),
  parentTerritoryId: z.number(),
  usageType: z.string(),
  itemTypes: z.string(),
  deregRes: z.boolean(),
  deregCandi: z.boolean(),
  centerPoint: z
    .object({
      latitude: z.number(),
      longitude: z.number(),
    })
    .optional(),
})

export type ClimateZone = z.infer<typeof climateZoneSchema>
